module.exports = __webpack_public_path__ + "assets/img/bc45269352a7e92731fa54b081b697a7.png";